import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRelatedPosts } from '../../features/relatedPosts/relatedPostsSlice';
import RelatedPostCard from '../RelatedPostCard/RelatedPostCard';

const RelatedPost = () => {
    const dispatch = useDispatch()
    const { details } = useSelector(state => state.details)
    const { relatedPosts, loading, } = useSelector(state => state.relatedPosts)
    useEffect(() => {
        if (details.id) {
            dispatch(getRelatedPosts({ ...details }))
        }
    }, [dispatch, details.id])
    return (
        <aside>
            <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">Related Posts</h4>
            <div className="space-y-4 related-post-container">
                {/* <!-- related post  --> */}
                {
                    loading ? <div className='text-center'>
                        Loading...
                    </div> : relatedPosts.length ? <>
                        {
                            relatedPosts.map(single => <RelatedPostCard {...single} key={single.id}></RelatedPostCard>)
                        }
                    </> : <div className='text-center'>
                        No Related Post Found
                    </div>
                }
                <RelatedPostCard></RelatedPostCard>
                <RelatedPostCard></RelatedPostCard>
            </div>
        </aside>
    );
};

export default RelatedPost;